<template>
    <div id="errorContainer">
        <div class="error-body">
            <div>
                <header class="mdc-top-app-bar" id="app-bar" ref="appBar">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">close</a>
                        </section>
                    </div>
                </header>
            </div>
            <div class="error-wrap">
                <div class="t-headline5">
                    {{$t('282')}}
                    <!-- 인터넷이 연결되지 않음 -->
                </div>
                <div class="t-body3 error-wrap-text">
                    {{$t('283')}} <br>
                    {{$t('284')}}
                    <!-- 오프라인 상태입니다. <br>
                    인터넷 연결 상태를 확인해주세요. -->
                    
                </div>
                <div>
                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="retry()" @keypress="retry()" tabindex="0">
                        {{$t('285')}}
                        <!-- 다시 시도하기  -->
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 네트워크 오류 컴포넌트(network error component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
    mounted() {
        this.setMaterialUi()
    },
    methods: {
        retry() {
            let redirectPath = this.$route.query.redirectPath || '/'
            this.$router.push(redirectPath)
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

        },
    }

}
</script>